Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "LandingPage";
exports.labelBodyText = "LandingPage Body";

exports.btnExampleTitle = "CLICK ME";
exports.seeMoreText = "See More"
exports.testimonialsText = "Testimonials"
exports.trendingArtistsText = "Trending Artists"
exports.fourEasyStepsText = "Get Artist in 4 easy steps"

exports.httpGetMethod = "GET"
exports.landingBannersApiEndpoint = "bx_block_content_management/landing_page"
exports.userListingApiEndPoint = "account_block/catalogues"
exports.testimonialsApiEndpoint = "bx_block_content_management/testimonials"

exports.emptyTestimonialsMessage = `There are no testimonials available at the moment.\nStay tuned for updates!`
// Customizable Area End